import angular from 'angular';
import { assign } from 'lodash';

import { InspectionRepairItemForm } from './inspection-repair-item-form';

module.exports = angular.module('admin.directives.inspection_repair_item', [
])
.directive('ocInspectionRepairItem', function() {
  return {
    restrict: 'EA',
    scope: {
      inspectionRepairItem: '=',
      onDelete: '=',
      editable: '=',
    },
    template: require('./inspection-repair-item.jade'),
    bindToController: true,
    controller: 'inspectionRepairItemCtrl',
    controllerAs: 'inspectionRepairItemCtrl',
  };
})
.controller('inspectionRepairItemCtrl', class {
  constructor(InspectionRepairItem) {
    this.InspectionRepairItem = InspectionRepairItem;
    this.inspectionRepairItem._editing = !this.inspectionRepairItem.id;
  }

  $onChanges() {
    this.initForm();
  }

  initForm() {
    // NOTE(edward): it's only safe to modify top level primitives on the form
    // if we could revert then we wouldn't have to worry about this. could also maybe use merge
    // assign(this.form, this.inspectionRepairItem);
    // this.editing = false;

    // NOTE(edward): not copying everything because photos are out of scope
    this.form = new InspectionRepairItemForm(this.inspectionRepairItem);
  }

  createOrUpdate() {
    const iri = new this.InspectionRepairItem(this.inspectionRepairItem);
    this.form.toInspectionRepairItem(iri);
    const action = iri.id ? '$update' : '$save';
    iri[action]().then(
     () => {
       delete this.inspectionRepairItem._editing;
       assign(this.inspectionRepairItem, iri);
       this.initForm();
     },
     () => this.inspectionRepairItem._editing = true
   );
  }

  deleteItem() {
    const iri = new this.InspectionRepairItem(this.inspectionRepairItem);
    iri.$delete(() => this.onDelete(this.inspectionRepairItem));
  }

  doneEditing() {
    this.initForm();
    delete this.inspectionRepairItem._editing;
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/inspections/inspection-repair-item.js
 **/